import {
   Capitalize,
   DateFormatter,
   DateTimeFormatter,
   FontColorContraster,
   LowerCase,
   TimeFormatter,
   UpperCase,
} from '@nxtpeople/nxt-vue-library';
import { App } from 'vue';

function setupDirectives(app: App<Element>) {
   app.directive('date-time', DateTimeFormatter);
   app.directive('date', DateFormatter);
   app.directive('time', TimeFormatter);
   app.directive('font-color-contrast', FontColorContraster);
   app.directive('uppercase', UpperCase);
   app.directive('lowercase', LowerCase);
   app.directive('capitalize', Capitalize);
}

export { setupDirectives };
